document.addEventListener("DOMContentLoaded", function () {
	const faqsBlock = document.querySelector(".faqs-block");

	if (!faqsBlock) {
		return;
	}

	const accordionItems = faqsBlock.querySelectorAll(".accordion-item");

	// Accordion toggle
	accordionItems.forEach((item) => {
		const button = item.querySelector(".accordion-button");
		const content = item.querySelector(".accordion-content");

		if (!button || !content) {
			return;
		}

		button.setAttribute("aria-expanded", "false");

		button.addEventListener("click", function () {
			const isActive = this.getAttribute("aria-expanded") === "true";

			// Close all other items
			accordionItems.forEach((otherItem) => {
				if (otherItem !== item) {
					const otherButton =
						otherItem.querySelector(".accordion-button");
					const otherContent =
						otherItem.querySelector(".accordion-content");
					if (otherButton && otherContent) {
						otherContent.classList.remove("active");
						otherButton.classList.remove("active");
						otherButton.setAttribute("aria-expanded", "false");
					}
				}
			});

			// Toggle clicked item
			if (isActive) {
				content.classList.remove("active");
				this.classList.remove("active");
				this.setAttribute("aria-expanded", "false");
			} else {
				content.classList.add("active");
				this.classList.add("active");
				this.setAttribute("aria-expanded", "true");
			}
		});
	});

	// Category filters
	const filterButtons = faqsBlock.querySelectorAll(".faqs-block__filter");

	filterButtons.forEach((button) => {
		button.addEventListener("click", function () {
			const category = this.dataset.category;

			// Update active state
			filterButtons.forEach((btn) => btn.classList.remove("active"));
			this.classList.add("active");

			// Filter accordion items
			accordionItems.forEach((item) => {
				if (category === "all") {
					item.style.display = "";
				} else {
					const itemCategories = item.dataset.categories || "";
					item.style.display = itemCategories
						.split(" ")
						.includes(category)
						? ""
						: "none";
				}

				// Close any open accordion when filtering
				const content = item.querySelector(".accordion-content");
				const btn = item.querySelector(".accordion-button");
				if (content && btn) {
					content.classList.remove("active");
					btn.classList.remove("active");
					btn.setAttribute("aria-expanded", "false");
				}
			});
		});
	});
});
